'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["name", "getInitials"];
/**
 * The avatar name
 */
var AvatarName = function AvatarName(props) {
  var name = props.name,
    getInitials = props.getInitials,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    role: "img",
    "aria-label": name
  }, rest, {
    __css: styles.label
  }), name ? getInitials === null || getInitials === void 0 ? void 0 : getInitials(name) : null);
};
exports.AvatarName = AvatarName;